import { AppState } from 'src/app/core/core.state'
import { ResourceEffects } from 'src/app/shared/resource-effects'

import { Injectable } from '@angular/core'
import { Actions } from '@ngrx/effects'
import { Store } from '@ngrx/store'

import { Message } from './message'
import { messageActions } from './message.actions'
import * as fromMessage from './message.reducer'
import { MessageService } from './message.service'

@Injectable()
export class MessageEffects extends ResourceEffects<Message> {
  constructor(
    public actions$: Actions,
    public store: Store<AppState>,
    public messageService: MessageService
  ) {
    super(fromMessage.FEATURE_NAME, messageService, messageActions, actions$)
  }
}
